import { useComplianceReport } from '@/api/reports';
import { LoadingSpinner } from '@/components/shared/loading-spinner';
import { ErrorMessage } from '@/components/shared/error-message';
import { EmptyState } from '@/components/shared/empty-state';
import { cn } from '@/lib/utils';
import { Users, AlertTriangle, CheckCircle } from 'lucide-react';
import { SummaryCard } from './summary-card';

export function ComplianceSection() {
  const { data, isLoading, error } = useComplianceReport();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message="No se pudo cargar el reporte de cumplimiento." />;
  if (!data) return <EmptyState title="Sin datos" description="No hay datos disponibles." />;

  const compliant = data.users.filter((u) => u.compliance_percent >= 100).length;
  const nonCompliant = data.users.length - compliant;

  return (
    <div className="space-y-6">
      <div className="grid gap-4 sm:grid-cols-3">
        <SummaryCard label="Total Usuarios" value={data.total_active_users} icon={Users} />
        <SummaryCard label="En Cumplimiento" value={compliant} icon={CheckCircle} />
        <SummaryCard label="Sin Cumplimiento" value={nonCompliant} icon={AlertTriangle} />
      </div>

      {data.users.length > 0 && (
        <div className="overflow-x-auto rounded-xl border border-border">
          <table className="w-full text-sm">
            <thead className="border-b border-border bg-muted/50">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-muted-foreground">Usuario</th>
                <th className="px-4 py-3 text-left font-medium text-muted-foreground">
                  Departamento
                </th>
                <th className="px-4 py-3 text-right font-medium text-muted-foreground">
                  Requeridos
                </th>
                <th className="px-4 py-3 text-right font-medium text-muted-foreground">
                  Completados
                </th>
                <th className="px-4 py-3 text-right font-medium text-muted-foreground">
                  Cumplimiento
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {data.users.slice(0, 50).map((u) => (
                <tr key={u.user_id} className="hover:bg-muted/30">
                  <td className="px-4 py-3 text-card-foreground">{u.user_name}</td>
                  <td className="px-4 py-3 text-card-foreground">{u.department}</td>
                  <td className="px-4 py-3 text-right">{u.total_required}</td>
                  <td className="px-4 py-3 text-right">{u.completed}</td>
                  <td className="px-4 py-3 text-right font-medium">
                    <span
                      className={cn(
                        u.compliance_percent >= 100 ? 'text-green-600' : 'text-amber-600',
                      )}
                    >
                      {u.compliance_percent}%
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
